module.exports = __webpack_public_path__ + "static/media/payments-banner.1914d674.jpg";